module.exports = __webpack_public_path__ + "static/media/white-tick.4733031f.svg";